import { render, staticRenderFns } from "./ClientReversals.vue?vue&type=template&id=4e6e290e&scoped=true&"
import script from "./ClientReversals.vue?vue&type=script&lang=js&"
export * from "./ClientReversals.vue?vue&type=script&lang=js&"
import style0 from "./ClientReversals.vue?vue&type=style&index=0&id=4e6e290e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6e290e",
  null
  
)

export default component.exports